import { useEffect } from "react";

/** Sets the browser tab title so each page is distinguishable in tabs and history. */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = `${title} · BillyPocket Admin`;
  }, [title]);
}
